export default function Logo({ size = 28, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Disko Bhute logo"
    >
      {/* Vinyl / sun — two concentric shapes with a severed quadrant */}
      <circle cx="24" cy="24" r="22" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="24" cy="24" r="12" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="24" cy="24" r="3" fill="#FF2A2A" />
      {/* Cut — the "ghost" slice */}
      <path d="M24 2 L24 24 L46 24" fill="none" stroke="#FF2A2A" strokeWidth="2" />
    </svg>
  );
}
